import Swiper, { Pagination, Navigation } from 'swiper';

const params = {
    parentSelector: '.recommend-slider.js-recommend-slider',
    containerSelector: '.js-recommend-slider .swiper-container',
    paginationSelector: '.js-recommend-slider .swiper-pagination',
};

Swiper.use([Pagination, Navigation]);

export function initRecommendSlider() {
    const container = $(params.containerSelector)[0];

    if (!container) {
        return;
    }

    const sliderType = $(params.parentSelector).data('type');
    let slidesCount = 4;

    if (sliderType === 'event') {
        slidesCount = 3;
    }

    const recommendSlider = new Swiper(container, {
        loop: false,
        spaceBetween: 16,
        slidersPerView: 1,
        pagination: {
            el: params.paginationSelector,
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: slidesCount,
            },
        },
    });

    recommendSlider.on('slideChange', (e) => {
        // eslint-disable-next-line prefer-rest-params
        console.log(e);
    });
}
